import React, { useState, useEffect } from 'react';
import { Select, Icon, Tooltip as AntdTooltip } from 'antd';

import Description from 'components/Description/Description';

import { getBuildingRegulationStatuses } from 'utils/apis/constants';

const Option = Select.Option;

const useAirbnbStatuses = () => {
  const [airbnbStatuses, setAirbnbStatuses] = useState([]);

  const convertToKeyValues = obj => {
    return Object.values(obj).reduce(
      (final, current) => {
        return final.concat([{ key: current.code, value: current.label }]);
      },
      [{ key: 'All', value: 'All' }]
    );
  };

  useEffect(() => {
    getBuildingRegulationStatuses()
      .then(res => convertToKeyValues(res.data))
      .then(data => setAirbnbStatuses(data));
  }, []);

  return airbnbStatuses;
};

const AirbnbFilter = ({ onSelectionChange }) => {
  const airbnbStatuses = useAirbnbStatuses();

  return (
    <>
      <Description size="large">
        STA Regulation Status{' '}
        <AntdTooltip title="STA a.k.a Short Term Accomodation">
          <Icon type="question-circle" theme="filled" />
        </AntdTooltip>{' '}
      </Description>
      <Select size="large" style={{ width: '100%', marginBottom: 16 }} defaultValue="All" onSelect={onSelectionChange}>
        {airbnbStatuses.map(status => (
          <Option key={status.key} value={status.key}>
            {status.value}
          </Option>
        ))}
      </Select>
    </>
  );
};

AirbnbFilter.defaultProps = {
  onSelectionChange: e => {}
};

export default AirbnbFilter;
